<template>
  <div>
    <TopicNav :topics="topics" :categories="categories" />
    <nuxt-page :key="$route.fullPath" @onCategories="(c) => (categories = c)" @onAllCategories="setAllCategories" />
  </div>
</template>
<script>
import topicPage, { TopicQuery } from '@/mixins/topicPage';
import TopicNav from '@/components/knowledge/TopicNav';
import { stripLocale } from '@/utils/i18n';

export default defineNuxtComponent({
  name: 'TopicWrapper',

  components: { TopicNav },

  mixins: [topicPage],

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;
    const slug = stripLocale(route.path, locale.value).split('/')[0];
    const uri = slug;
    const variables = { site: locale.value, uri, slug };

    const { entry, topics, categories: allCategories, seomatic } = await $craftRequest(TopicQuery, variables);

    return { entry, topics, allCategories, seomatic };
  },

  data() {
    return {
      topics: [],
      categories: [],
      allCategories: [],
    };
  },

  methods: {
    // set full-Categories list
    setAllCategories() {
      this.categories = this.allCategories.map((category) => ({
        ...category,
        route: {
          name: `knowledge-index-category-slug___${this.$i18n.locale}`,
          params: { slug: category.slug },
        },
      }));
    },
  },
});
</script>
